import { takeEvery } from 'redux-saga/effects';
import { consts as uploadDocuments } from './upload-user-documents';
import { consts as updateDocuments } from './update-user-documents';
import { consts as deleteDocuments } from './delete-user-documents';
import { handleServerErrorWithToast } from '../../utils/ui/handleServerErrorsWithToast';

export default function* handleDocumentsErrorsSaga() {
  yield takeEvery(
    [
      uploadDocuments.REJECTED,
      uploadDocuments.ERROR_ENCOUNTERED,
      updateDocuments.REJECTED,
      updateDocuments.ERROR_ENCOUNTERED,
      deleteDocuments.REJECTED,
      deleteDocuments.ERROR_ENCOUNTERED,
    ],
    handleServerErrorWithToast,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/handle-documents-error-saga.js